import Button from '@jetbrains/ring-ui/components/button/button'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import classNames from 'classnames'
import * as React from 'react'

import PopupMenu from '../../../common/Popup/PopupMenu'

import type {HealthItemActionsProps} from './HealthItem.types'

import styles from './HealthItem.css'

function HealthItemActions(props: HealthItemActionsProps) {
  const {grouped, showMore, hidePersonal, hideGlobal, category} = props
  const className = classNames(styles.hideButtons, props.className, {
    [styles.hideButtonsGrouped]: grouped,
    [styles.hideButtonsSingle]: !grouped,
  })

  const hideMenu = React.useMemo(
    () => [
      {
        key: 'hide_for_me',
        label: 'Hide for me',
        onClick: hidePersonal,
      },
      {
        key: 'hide_all',
        label: 'Hide for everyone',
        onClick: hideGlobal,
      },
    ],
    [hideGlobal, hidePersonal],
  )

  if (typeof showMore === 'function') {
    return (
      <Button
        className={className}
        text
        onClick={showMore}
        aria-label={`Health report item: ${category.name}. Open popup for full info.`}
      >
        {'Show more'}
      </Button>
    )
  } else {
    if (hidePersonal && !hideGlobal) {
      return (
        <Button className={className} text onClick={hidePersonal}>
          {'Hide'}
        </Button>
      )
    }

    if (hidePersonal && hideGlobal) {
      return (
        <Dropdown className={className} anchor={'Hide'}>
          <PopupMenu data={hideMenu} />
        </Dropdown>
      )
    } else {
      return null
    }
  }
}

export default HealthItemActions
